import { lazy, Suspense, useEffect, useState } from 'react'
import UberEatsBanner from '../uberEats/UberEatsBanner'
import UberEatsHelp from '../uberEats/UberEatsHelp'

const ShuttleAppreciation = lazy(() => import('../../shuttle_software/ShuttleAppreciation'));
const TaxiFaq = lazy(() => import('../../taxiDispatchSoftware/TaxiFaq'));
const GroceryMarket = lazy(() => import('../groceryApp/GroceryMarket'));
const UberEatsAdvance = lazy(() => import('../uberEats/UberEatsAdvance'));
const UberEatsBenifits = lazy(() => import('../uberEats/UberEatsBenifits'));
const UberEatsDemand = lazy(() => import('../uberEats/UberEatsDemand'));
const UberEatsLove = lazy(() => import('../uberEats/UberEatsLove'));
const UberEatsOffer = lazy(() => import('../uberEats/UberEatsOffer'));
const UberEatsPower = lazy(() => import('../uberEats/UberEatsPower'));
const UberEatsProcess = lazy(() => import('../uberEats/UberEatsProcess'));
const UberEatsRevenue = lazy(() => import('../uberEats/UberEatsRevenue'));
const UberEatsScript = lazy(() => import('../uberEats/UberEatsScript'));
const UberEatsSteps = lazy(() => import('../uberEats/UberEatsSteps'));
const UberEatsUnique = lazy(() => import('../uberEats/UberEatsUnique'));

const bannerData = {
  heading: "Deliveroo Clone App",
  desc: "Our AI-powered Deliveroo Clone App delivers a lightning-fast, reliable, and personalized food delivery experience—helping restaurants and customers across the USA connect seamlessly through smart, digital-first solutions.",
  cta: "Get free demo",
  image: "/assets/home/uber-eats-banner.webp",
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "deliveroo Clone App",
        slug: ""
      },
    ]
  }
}

const helpData = {
  headingPart1: "What Is an",
  headingPart2: "Deliveroo Clone",
  headingPart3: "& How Does It Help?",
  desc: [
    "A Deliveroo clone is a pre-built food delivery solution that mirrors the successful Deliveroo model while being fully customizable for your brand. It includes customer-facing apps, restaurant management dashboards, delivery partner tools, and a powerful admin panel. With branding flexibility and AI-powered integrations, this ready-made script saves months of costly development.",

    "By leveraging Mobility Infotech’s Deliveroo Clone App, U.S. food delivery businesses and entrepreneurs can launch their platforms rapidly and focus on scaling customer acquisition, building partnerships, and expanding their market presence instead of worrying about technical complexities."
  ]
}

const processData = {
  headingPart1: "How",
  headingPart2: "AI-Fueled Deliveroo",
  headingPart3: "like app Streamlines Process?",
  subHeading: "The AI-powered Deliveroo-like app from Mobility Infotech revolutionizes the delivery process with automation, predictive insights, and real-time optimization. From smart order routing to proactive customer engagement, AI ensures efficiency at every step.",
  boxes: [
    {
      image1: "/assets/home/uber-eats-process-1.webp",
      image2: "/assets/home/uber-eats-process-hover-1.webp",
      head: "AI Personalisation Engine",
      desc: "Machine learning and NLP enable the app to understand customer preferences and suggest curated dishes—delivering a hyper-personalized dining experience.",
    },
    {
      image1: "/assets/home/uber-eats-process-2.webp",
      image2: "/assets/home/uber-eats-process-hover-2.webp",
      head: "AI-Aided Virtual Assistant",
      desc: "The integrated virtual assistant answers customer queries, tracks deliveries, and resolves issues instantly—ensuring quick and frictionless support.",
    },
    {
      image1: "/assets/home/uber-eats-process-3.webp",
      image2: "/assets/home/uber-eats-process-hover-3.webp",
      head: "AI-Centric Dynamic Pricing",
      desc: "Using real-time demand, timing, and geo-data, AI adjusts pricing dynamically—driving higher revenues while keeping competitive market rates.",
    },
  ]
}

const benifitData = {
  label: "AI-ENABLED Benefits In",
  headingPart1: "Encounter",
  headingPart2: "The Advantages of",
  headingPart3: "Our Deliveroo Clone App",
  subHeading: "Mobility Infotech integrates advanced AI features to help your business outperform the competition with improved speed, personalization, and operational efficiency.",
  allTabs: [
    {
      name: "Eater",
      data: [
        {
          image: "/assets/home/uber-eats-eater-1.webp",
          mainImage: "/assets/home/uber-eats-eater-main1.webp",
          title: "Takeaway Option",
          desc: "AI recommends smart pickup times and popular dishes for faster takeaways.",
        },
        {
          image: "/assets/home/uber-eats-eater-2.webp",
          mainImage: "/assets/home/uber-eats-eater-main2.webp",
          title: "Support Option",
          desc: "AI-powered support offers instant resolutions to customer queries.",
        },
        {
          image: "/assets/home/uber-eats-eater-3.webp",
          mainImage: "/assets/home/uber-eats-eater-main3.webp",
          title: "Tips Option",
          desc: "Smart tip suggestions tailored to customer history and order size.",
        },
        {
          image: "/assets/home/uber-eats-eater-4.webp",
          mainImage: "/assets/home/uber-eats-eater-main4.webp",
          title: "Payment Gateway",
          desc: "Secure and AI-monitored transactions with fraud detection.",
        },
        {
          image: "/assets/home/uber-eats-eater-5.webp",
          mainImage: "/assets/home/uber-eats-eater-main5.webp",
          title: "Profile Management",
          desc: "AI-driven personalization saves preferences, diets, and past history.",
        },
      ],
    },
    {
      name: "restaurant Owner",
      data: [
        {
          image: "/assets/home/uber-eats-eater-1.webp",
          mainImage: "/assets/home/uber-eats-restaurant-main1.webp",
          title: "Takeaway Option",
          desc: "Boost takeaway orders with AI-driven menu recommendations and pricing insights.",
        },
        {
          image: "/assets/home/uber-eats-eater-2.webp",
          mainImage: "/assets/home/uber-eats-restaurant-main2.webp",
          title: "Profile Management",
          desc: "Leverage AI to analyze customer behavior, feedback, and demand trends.",
        },
        {
          image: "/assets/home/uber-eats-eater-3.webp",
          mainImage: "/assets/home/uber-eats-restaurant-main3.webp",
          title: "Multiple Language",
          desc: "AI-enabled translations help restaurants reach diverse U.S. customer groups.",
        },
      ],
    },
    {
      name: "DELIVERY PROVIDER",
      data: [
        {
          image: "/assets/home/uber-eats-eater-1.webp",
          mainImage: "/assets/home/uber-eats-delivery-main1.webp",
          title: "Single Pickup/Multiple Delivery Option",
          desc: "AI optimizes batch deliveries, reducing costs and maximizing efficiency.",
        },
        {
          image: "/assets/home/uber-eats-eater-2.webp",
          mainImage: "/assets/home/uber-eats-delivery-main2.webp",
          title: "Tips Option",
          desc: "AI recommendations increase tipping opportunities fairly.",
        },
        {
          image: "/assets/home/uber-eats-eater-3.webp",
          mainImage: "/assets/home/uber-eats-delivery-main3.webp",
          title: "Profile Management",
          desc: "Track ratings, earnings, and performance with AI insights.",
        },
        {
          image: "/assets/home/uber-eats-eater-4.webp",
          mainImage: "/assets/home/uber-eats-delivery-main4.webp",
          title: "Multiple Language",
          desc: "Smooth multi-language communication across diverse U.S. regions.",
        },
        {
          image: "/assets/home/uber-eats-eater-5.webp",
          mainImage: "/assets/home/uber-eats-delivery-main5.webp",
          title: "Navigation Option",
          desc: "Real-time AI-powered navigation ensures faster deliveries.",
        },
      ],
    },
    {
      name: "ADMIN",
      data: [
        {
          image: "/assets/home/uber-eats-eater-1.webp",
          mainImage: "/assets/home/uber-eats-admin-main1.webp",
          title: "Separate Eaters, Drivers, Restaurant Management",
          desc: "Manage all stakeholders seamlessly with AI-driven clarity.",
        },
        {
          image: "/assets/home/uber-eats-eater-2.webp",
          mainImage: "/assets/home/uber-eats-admin-main2.webp",
          title: "Single Pickup/Multiple Delivery Option",
          desc: "Enhance logistics by streamlining multiple order deliveries.",
        },
        {
          image: "/assets/home/uber-eats-eater-3.webp",
          mainImage: "/assets/home/uber-eats-admin-main3.webp",
          title: "Support Option",
          desc: "AI-powered chat support resolves issues instantly.",
        },
        {
          image: "/assets/home/uber-eats-eater-4.webp",
          mainImage: "/assets/home/uber-eats-admin-main4.webp",
          title: "Admin Management & Roles",
          desc: "Assign roles and track performance with AI-generated insights.",
        },
        {
          image: "/assets/home/uber-eats-eater-5.webp",
          mainImage: "/assets/home/uber-eats-admin-main5.webp",
          title: "Easy Driver Document Management",
          desc: "Automated driver verification and onboarding powered by AI.",
        },
      ],
    }
  ]

}

const stepData = {
  headingPart1: "Step-By-Step Order Flow",
  headingPart2: "In A Deliveroo Clone App",
  subHeading: "Explore the complete order flow of a Deliveroo clone app, from browsing restaurants to doorstep delivery.",
  image: "",
}

const forYouData = {
  newClass: "uber-eats-for-you",
  text1: "$50 Billion+ Market",
  text2: "Opportunity",
  des: "On-demand grocery delivery apps are rapidly capturing global market share and consumer demand.",
  btn: "Build Your App",
}

const scriptData = {
  titlePart1: "Best",
  titlePart2: "Food Delivery Scripts",
  titlePart3: "to Launch Your On-Demand App",
  description: "Launch your own food delivery business with these top-rated food delivery scripts inspired by global brands.",
}

const demandData = {
  image: "/assets/home/uber-eats-demand.webp",
  titlePart1: "Lead the",
  titlePart2: "On-Demand Food",
  titlePart3: "Delivery World",
  desc: "With the U.S. food delivery market booming, Mobility Infotech’s Deliveroo Clone Script positions your business to grow fast and scale efficiently. Packed with customizable features, real-time tracking, and multi-payment integrations, it helps you build a trusted, competitive food delivery platform in record time.",
  desc2: "",
  cta: "Schedule a meeting"
}

const RevenueData = {
  titlePart1: "How",
  titlePart2: "Deliveroo Clone Apps",
  titlePart3: "Are Making Revenue?",
  desc: "Ultimate Earning Sources of Our Deliveroo Clone Script",
  boxes: [
    {
      image: "/assets/home/eats-revenue-1.webp",
      heading: "Commission Fee",
      description: "Earn revenue from every transaction by charging service fees.",
    },
    {
      image: "/assets/home/eats-revenue-2.webp",
      heading: "Dynamic Surge Pricing",
      description: "Maximize profit with AI-powered surge pricing during peak times.",
    },
    {
      image: "/assets/home/eats-revenue-3.webp",
      heading: "Referral Earnings",
      description: "Encourage referrals with rewards, growing your user base steadily.",
    },
    {
      image: "/assets/home/eats-revenue-4.webp",
      heading: "Showcase The Sponsors",
      description: "Offer premium placements for restaurants through sponsored listings.",
    },
    {
      image: "/assets/home/eats-revenue-5.webp",
      heading: "Flexible Commissions",
      description: "Customize commission rates based on order volume, demand, or popularity.",
    },
  ]
}

const uniqueData = {
  titlePart1: "What Makes Us",
  titlePart2: "Unique?",
  desc: "Mobility Infotech’s Deliveroo Clone Script comes with unmatched benefits tailored to U.S. food delivery startups and enterprises.",
  boxes: [
    {
      image: "/assets/home/uber-eats-unique-1.webp",
      heading: "Free Server Installation",
      description: "Quick and seamless deployment.",
    },
    {
      image: "/assets/home/uber-eats-unique-2.webp",
      heading: "Free App Submission",
      description: "Support for App Store & Play Store.",
    },
    {
      image: "/assets/home/uber-eats-unique-1.webp",
      heading: "Free Bug Support",
      description: "Bug fixes during the support period.",
    },
    {
      image: "/assets/home/uber-eats-unique-4.webp",
      heading: "On-Time Support",
      description: "Reliable customer service across channels.",
    },
    {
      image: "/assets/home/uber-eats-unique-5.webp",
      heading: "100% Source Code",
      description: "Full ownership and flexibility for scaling.",
    },
    {
      image: "/assets/home/uber-eats-unique-6.webp",
      heading: "Native IOS & Android Apps",
      description: "Optimized performance on both platforms.",
    },
    {
      image: "/assets/home/uber-eats-unique-7.webp",
      heading: "Support After App Rejection",
      description: "Guidance to resubmit and approve apps.",
    },
    {
      image: "/assets/home/uber-eats-unique-8.webp",
      heading: "Free Technical Support",
      description: "Assistance with third-party integrations.",
    },
    {
      image: "/assets/home/uber-eats-unique-9.webp",
      heading: "Free White Labeling",
      description: "Replace our branding with yours, completely.",
    },
  ]
}

const loveData = {
  titlePart1: "Unique Features",
  titlePart2: "You’ll Love",
  desc: "Explore the powerful, user-focused features that make the Mobility Infotech platform stand out. Designed for performance, scalability, and ease of use, each function is built to elevate your food delivery business.",
  boxes: [
    {
      image: "/assets/home/uber-eats-love-1.webp",
      heading: "Admin Management & Roles",
      description: "Total control from one dashboard.",
    },
    {
      image: "/assets/home/uber-eats-love-2.webp",
      heading: "Unique Dashboards",
      description: "Panels for eaters, drivers, and restaurants.",
    },
    {
      image: "/assets/home/uber-eats-love-3.webp",
      heading: "Easy Driver Documentation",
      description: "Quick verification for trust and security.",
    },
    {
      image: "/assets/home/uber-eats-love-4.webp",
      heading: "Live Tracking",
      description: "Track every delivery step in real time.",
    },
    {
      image: "/assets/home/uber-eats-love-5.webp",
      heading: "Review Management",
      description: "Handle reviews and issues efficiently.",
    },
    {
      image: "/assets/home/uber-eats-love-6.webp",
      heading: "Reports",
      description: "Exportable data for performance insights.",
    },
    {
      image: "/assets/home/uber-eats-love-7.webp",
      heading: "Geo-Location Search",
      description: "Accurate restaurant and delivery mapping.",
    },
    {
      image: "/assets/home/uber-eats-love-8.webp",
      heading: "Real-Time Currency Rates",
      description: "Seamless cross-border expansion.",
    },
    {
      image: "/assets/home/uber-eats-love-9.webp",
      heading: "Quick Business Launch",
      description: "Deploy faster with a ready-to-use platform.",
    },
  ]
}

const forYouTwoData = {
  newClass: "uber-eats-for-you-two",
  text1: "Leaders in Food",
  text2: "Delivery Innovation",
  des: "Innovative food delivery solutions designed for seamless experiences, business growth, and long-term market success.",
  btn: "Build Your App",
}

const powerData = {
  titlePart1: "Power Up with",
  titlePart2: "Add-Ons",
  desc: "Expand your business capabilities with advanced add-ons:",
  boxes: [
    {
      image: "/assets/home/uber-eats-power-1.webp",
      heading: "Multiple Language",
      description: "Cater to America’s diverse customer base with multilingual support.",
    },
    {
      image: "/assets/home/uber-eats-power-2.webp",
      heading: "RTL Support",
      description: "Provide right-to-left layouts for communities using Arabic or Hebrew.",
    },
    {
      image: "/assets/home/uber-eats-power-3.webp",
      heading: "Modifiers",
      description: "Let restaurants add custom choices like toppings, sauces, or meal upgrades.",
    },
    {
      image: "/assets/home/uber-eats-power-4.webp",
      heading: "ChatGPT",
      description: "Offer AI-powered chat for instant order help and smart recommendations.",
    },
    {
      image: "/assets/home/uber-eats-power-5.webp",
      heading: "Algolia Search",
      description: "Deliver ultra-fast, precise restaurant and menu searches across U.S. cities.",
    },
    {
      image: "/assets/home/uber-eats-power-6.webp",
      heading: "Crypto Wallet",
      description: "Accept Bitcoin, Ethereum, and other cryptocurrencies securely in-app.",
    },
    {
      image: "/assets/home/uber-eats-power-7.webp",
      heading: "Kiosk",
      description: "Enable self-service kiosks in partner restaurants for quick, contactless ordering.",
    },
    {
      image: "/assets/home/uber-eats-power-8.webp",
      heading: "Sunmi Integration",
      description: "Seamlessly connect with SUNMI POS devices for smooth U.S. restaurant operations.",
    },
    {
      image: "/assets/home/uber-eats-power-9.webp",
      heading: "Local Pay Gateway",
      description: "Integrate popular U.S. payment gateways like Stripe, PayPal, or Square.",
    },
    {
      image: "/assets/home/uber-eats-power-10.webp",
      heading: "Other Maps",
      description: "Add alternative mapping services to optimize delivery routes nationwide.",
    },
    {
      image: "/assets/home/uber-eats-power-11.webp",
      heading: "Local SMS Gateway",
      description: "Send real-time order updates through trusted U.S. SMS providers.",
    },
    {
      image: "/assets/home/uber-eats-power-12.webp",
      heading: "External DB Backup",
      description: "Protect platform data with secure, automatic external backups.",
    },
    {
      image: "/assets/home/uber-eats-power-13.webp",
      heading: "Driver Subscription",
      description: "Let drivers subscribe for premium perks or priority order access.",
    },
    {
      image: "/assets/home/uber-eats-power-14.webp",
      heading: "Driver Wallet",
      description: "Give delivery partners an in-app wallet to track and withdraw earnings.",
    },
    {
      image: "/assets/home/uber-eats-power-15.webp",
      heading: "Store own driver",
      description: "Allow restaurants to track and manage deliveries using their own staff.",
    },
    {
      image: "/assets/home/uber-eats-power-16.webp",
      heading: "Bidding System",
      description: "Enable drivers to bid for delivery requests for competitive pricing and faster service.",
    },
  ]
}

const advanceData = {
  titlePart1: "Advance",
  titlePart2: "Add-Ons",
  desc: "Take your Deliveroo Clone App to the next level with AI-powered advanced features:",
  boxes: [
    {
      image: "/assets/home/uber-eats-advance-1.webp",
      backImage: "/assets/home/uber-eats-advance-back1.webp",
      heading: "ChatBots (AI-Powered)",
      description: "24/7 automated customer assistance.",
    },
    {
      image: "/assets/home/uber-eats-advance-2.webp",
      backImage: "/assets/home/uber-eats-advance-back2.webp",
      heading: "Push Alerts",
      description: "Personalized notifications.",
    },
    {
      image: "/assets/home/uber-eats-advance-3.webp",
      backImage: "/assets/home/uber-eats-advance-back3.webp",
      heading: "Optimised Bookings",
      description: "Predictive scheduling for peak demand.",
    },
  ]
}

const offerData = {
  label: "Our Offerings",
  headingPart1: "What Do",
  headingPart2: "We Offer?",
  headingPart3: "",
  subHeading: "At Mobility Infotech, we build a robust and feature-rich Deliveroo Clone App tailored for the USA market. Our solution comes with powerful and intuitive user panels designed to make ordering, delivery, and restaurant management effortless. From customers to restaurants, and delivery partners to admins, we bring everyone together into one smooth-running ecosystem.",
  allTabs: [
    {
      name: "Eaters",
      boxes: [
        {
          image: "/assets/home/uber-eats-offer-1.webp",
          heading: "Eaters Android",
          description: "Lets users search for nearby restaurants, explore cuisines, place orders, track deliveries in real time, and save favorites.",
        },
        {
          image: "/assets/home/uber-eats-offer-2.webp",
          heading: "Eaters  iOS",
          description: "A seamless iOS app where customers can browse restaurants, order meals, reorder favorites, and track past orders.",
        },
        {
          image: "/assets/home/uber-eats-offer-3.webp",
          heading: "Eaters Web panel",
          description: "A simple web interface for customers to discover restaurants, customize meals, place orders, and monitor delivery status.",
        },
      ]
    },
    {
      name: "restaurant",
      boxes: [
        {
          image: "/assets/home/uber-eats-offer-1.webp",
          heading: "Restaurant Owner Android",
          description: "A dedicated Android app for restaurant owners to accept and manage orders, update menus, track deliveries, and monitor sales in real-time.",
        },
        {
          image: "/assets/home/uber-eats-offer-2.webp",
          heading: "Restaurant Owner  iOS",
          description: "A dynamic iOS app that helps restaurants streamline order handling, tracking, push offers, and communicate with customers seamlessly.",
        },
        {
          image: "/assets/home/uber-eats-offer-3.webp",
          heading: "Restaurant Owner Web panel",
          description: "A comprehensive web dashboard to manage menus, monitor incoming orders, check earnings, and analyze restaurant performance with ease.",
        },
      ]
    },
    {
      name: "provider",
      boxes: [
        {
          image: "/assets/home/uber-eats-offer-1.webp",
          heading: "provider Android",
          description: "A user-friendly Android app for delivery partners to accept orders, view optimized routes, and manage earnings.",
        },
        {
          image: "/assets/home/uber-eats-offer-2.webp",
          heading: "provider  iOS",
          description: "An intuitive iOS app for delivery partners with real-time order alerts, turn-by-turn navigation, and earnings summary.",
        },
        {
          image: "/assets/home/uber-eats-offer-3.webp",
          heading: "provider Web panel",
          description: "A convenient web panel for delivery providers to manage availability, track assigned deliveries, and review past trips.",
        },
      ]
    },
    {
      name: "Admin",
      boxes: [
        {
          image: "/assets/home/uber-eats-offer-3.webp",
          heading: "Admin Web panel",
          description: "A powerful admin dashboard to manage restaurants, delivery partners, and customers. Admins can track operations, monitor revenue, generate reports, manage offers/commissions, and ensure smooth functioning of the entire platform.",
        },
      ]
    },

  ]
}

const faqData = [
  {
    id: "0",
    question: "01. What is a Deliveroo Clone app by Mobility Infotech?",
    answer: "It’s a ready-made food delivery solution replicating Deliveroo’s model, fully customizable with your branding and features.",
  },
  {
    id: "1",
    question: "02. How long does it take to launch?",
    answer: "Just a few days—with free installation, app submissions, and white labeling.",
  },
  {
    id: "2",
    question: "03. Is it customizable? ",
    answer: "Yes, 100%—from design to integrations, tailored for U.S. markets.",
  },
  {
    id: "3",
    question: "04. How does AI benefit my app?",
    answer: "AI improves route efficiency, personalization, support automation, and pricing strategies.",
  },
  {
    id: "4",
    question: "05. Do I get source code?",
    answer: "Yes, complete source code access is included with select packages.",
  },
  {
    id: "5",
    question: "06. What platforms are supported?",
    answer: "Native Android, iOS apps, plus restaurant, driver, and admin web panels.",
  },

  {
    id: "6",
    question: "07. How does the revenue model work?",
    answer: "Through commissions, surge pricing, referrals, sponsored listings, and flexible fees.",
  },
];

export default function DeliverooClone() {
  const [isScroll, setIsScroll] = useState(false);
  
    useEffect(() => {
      const handleScroll = () => {
        if (window.scrollY > 300) {
          setIsScroll(true);
        }
      };
  
      window.addEventListener("scroll", handleScroll);
  
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);
  return (
    <>
      <UberEatsBanner data={bannerData} />
      <UberEatsHelp data={helpData} />

      <Suspense fallback={null}>
        <UberEatsProcess data={processData} />
        {isScroll && (
          <>
            <UberEatsBenifits data={benifitData} />
            <UberEatsSteps data={stepData} />
            <GroceryMarket data={forYouData} />
            <UberEatsScript data={scriptData} />
            <UberEatsDemand data={demandData} />
            <UberEatsRevenue data={RevenueData} />
            <UberEatsUnique data={uniqueData} />
            <UberEatsLove data={loveData} />
            <GroceryMarket data={forYouTwoData} />
            <UberEatsPower data={powerData} />
            <UberEatsAdvance data={advanceData} />
            <UberEatsOffer data={offerData} />
            <ShuttleAppreciation />
            <div className="zip-faq-fixer">
              <TaxiFaq faqData={faqData} />
            </div>
          </>
        )}
      </Suspense>
    </>
  )
}
